module.exports = __webpack_public_path__ + "img/remove_circle_outline.558922b2.svg";